import styled from 'styled-components';
import media from '../../styled/media';

export const H3 = styled.h3`
  font-size: 24px;
  line-height: 36px;
  margin: 20px 0;
  font-weight: 400;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const IntroContainer = styled.div`
  background: url('/images/our-story/intro-xs.jpg') no-repeat center;
  background-size: cover;
  ${media.tablet`
    background-image: url('/images/our-story/intro.jpg');
  `}
`;

export const Intro = styled.div`
  height: 488px;
  padding: 20px;
  ${media.tablet`
    height: 664px;
    padding: 0;
    display: flex;
    align-items: center;
  `}
`;

export const IntroText = styled.h1`
  font-weight: 400;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
    text-align: left;
    max-width: 590px;
  `}
`;

export const Backdrop = styled.div`
  background: #f5f5f5;
`;

export const Mission = styled.div`
  text-align: center;
  padding: 40px 0;
  ${media.tablet`
    padding: 63px; 0;
    display: flex;
    text-align: left;
    align-items: center;
    flex-direction: row-reverse;
  `}
`;

export const MissionCell = styled.div`
  ${media.tablet`
    flex: 1;
    padding: 0 12px;
  `}
`;

export const MissionVideo = styled.video`
  width: 100%;
  display: block;
`;

export const MissionText = styled.p`
  font-size: 16px;
  line-height: 24px;
  ${media.tablet`
    font-size: 18px;
    line-height: 27px;
    max-width: 520px;
  `}
`;

export const About = styled.div`
  text-align: center;
  padding: 20px 0 40px;
  ${media.tablet`
    padding: 76px 0 96px;
  `}
`;

export const AboutText = styled.p`
  font-size: 14px;
  line-height: 24px;
  ${media.tablet`
    font-size: 18px;
    line-height: 27px;
    max-width: 856px;
    margin: 0 auto;
  `}
`;

export const AboutImageMobile = styled.div`
  margin-top: 36px;
  ${media.tablet`
    display: none;
  `}
`;

export const AboutImageDesktop = styled.div`
  display: none;
  ${media.tablet`
    margin-top: 72px;
    display: block;
  `}
`;

export const LI = styled.li`
  display: list-item;
  list-style: disc;
  font-size: 14px;
  line-height: 24px;
  ${media.tablet`
    font-size: 18px;
    line-height: 27px;
  `}
`;

export const HalfBlock = styled.div`
  padding: 20px 0;
  max-width: 100%;
  ${media.tablet`
    max-width: 50%;
  `};
  ul {
    margin-left: 40px;
  }
`;

export const HowItWorks = styled(HalfBlock)`
  ${media.tablet`
    margin-left: auto;
  `};
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 24px;
  ${media.tablet`
    font-size: 18px;
    line-height: 27px;
  `}
`;

export const Technology = styled(HalfBlock)`
  ${media.tablet`
    margin-left: auto;
  `};
`;

export const Story = styled(HalfBlock)`
  ${media.tablet`
    margin-left: auto;
  `}
`;
